import React from 'react';
import TauriPieVisual from '../TauriPieVisual/TauriPieVisual';
import TauriLineVisual from '../TauriLineVisual/TauriLineVisual';
import TauriBarVisual from '../TauriBarVisual/TauriBarVisual';
import TauriHorizontalBarVisual from '../TauriHorizontalBarVisual/TauriHorizontalBarVisual';
import TauriComboVisual from '../TauriComboVisual/TauriComboVisual';
import TauriSummaryVisual from '../TauriSummaryVisual/TauriSummaryVisual';
import TauriBubbleVisual from '../TauriBubbleVisual/TauriBubbleVisual';
import TauriStackedBarVisual from '../TauriStackedBarVisual/TauriStackedBarVisual';
import TauriTreeMapVisual from '../TauriTreeMapVisual/TauriTreeMapVisual';
import TauriGaugeVisual from '../TauriGaugeVisual/TauriGaugeVisual';
import TauriAdvancedTableVisual from '../TauriAdvancedTableVisual/TauriAdvancedTableVisual';
import TauriHistoricalTableVisual from '../TauriHistoricalTableVisual/TauriHistoricalTableVisual';
import {
  PieVisualConfiguration,
  VerticalBarVisualConfiguration,
  LineVisualConfiguration,
  HorizontalBarVisualConfiguration,
  ComboVisualConfiguration,
  HorizontalStackedBarVisualConfiguration,
  TreeMapVisualConfiguration,
  GaugeVisualConfiguration,
  BubbleVisualConfiguration,
  TableConfiguration
} from './TauriVisualChartConfiguration/TauriVisualChartConfiguration';

const TauriVisualFactory = (visual, chartData, chartPalettes, columnSize, rowSize, palettes, themes, onLoadData, paginationProps) => {
  switch (visual.type) {
    case 'donut':
    case 'pie':
      return <TauriPieVisual chartConfig={visual} chartData={chartData} chartOptions={PieVisualConfiguration} columnSize={columnSize} rowSize={rowSize} palettes={palettes} themes={themes} chartPalettes={chartPalettes} />;
    case 'line':
      return <TauriLineVisual chartConfig={visual} chartData={chartData} chartOptions={LineVisualConfiguration} columnSize={columnSize} rowSize={rowSize} palettes={palettes} themes={themes} chartPalettes={chartPalettes} />;
    case 'bar':
      return <TauriBarVisual chartConfig={visual} chartData={chartData} chartOptions={VerticalBarVisualConfiguration} columnSize={columnSize} rowSize={rowSize} palettes={palettes} themes={themes} chartPalettes={chartPalettes} />
    case 'combo':
      return <TauriComboVisual chartConfig={visual} chartData={chartData} chartOptions={ComboVisualConfiguration} columnSize={columnSize} rowSize={rowSize} palettes={palettes} themes={themes} chartPalettes={chartPalettes} />;
    case 'summary':
      return <TauriSummaryVisual chartConfig={visual} chartData={chartData} chartOptions={ComboVisualConfiguration} columnSize={columnSize} rowSize={rowSize} palettes={palettes} themes={themes} chartPalettes={chartPalettes} />;
    case 'bubble':
      return <TauriBubbleVisual chartConfig={visual} chartData={chartData} chartOptions={BubbleVisualConfiguration} columnSize={columnSize} rowSize={rowSize} palettes={palettes} themes={themes} chartPalettes={chartPalettes} />;
    case 'stacked':
      return <TauriStackedBarVisual chartConfig={visual} chartData={chartData} chartOptions={HorizontalStackedBarVisualConfiguration} columnSize={columnSize} rowSize={rowSize} palettes={palettes} themes={themes} chartPalettes={chartPalettes} />;
    case 'treemap':
      return <TauriTreeMapVisual chartConfig={visual} chartData={chartData} chartOptions={TreeMapVisualConfiguration} columnSize={columnSize} rowSize={rowSize} palettes={palettes} themes={themes} chartPalettes={chartPalettes} />;
    case 'radialBar':
      return <TauriGaugeVisual chartConfig={visual} chartData={chartData} chartOptions={GaugeVisualConfiguration} columnSize={columnSize} rowSize={rowSize} palettes={palettes} themes={themes} chartPalettes={chartPalettes} />;
    case 'advancedTable':
      return <TauriAdvancedTableVisual tableConfig={visual} tableData={chartData} tableOptions={TableConfiguration} columnSize={columnSize} rowSize={rowSize} palettes={palettes} themes={themes} chartPalettes={chartPalettes} onLoadData={onLoadData} paginationProps={paginationProps} />
    case 'historicalTable':
      return <TauriHistoricalTableVisual tableConfig={visual} tableData={chartData} tableOptions={TableConfiguration} columnSize={columnSize} rowSize={rowSize} palettes={palettes} themes={themes} chartPalettes={chartPalettes} onLoadData={onLoadData} paginationProps={paginationProps} />
    default:
      return null;
  }
};

export default TauriVisualFactory;